import $ from "jquery";
// FIXME: only for demonstration. Use accordion plugin. Use "enquire" to bind only on the right breakpoint

const offcanvas = {
    target: $('.js-hamburger'),
    bindHamburger() {
        this.target.on('click', (evt) => {
            let self = $(evt.currentTarget);

            if (self.hasClass('is-active')) {
                this.hideMobileNav();
            } else {
                this.showMobileNav();
            }
        });
    },
    showMobileNav() {
        this.target.addClass('is-active');
        $('html').addClass('l-offcanvas l-offcanvas--mobile-nav');
    },
    hideMobileNav() {
        this.target.removeClass('is-active');
        $('html').removeClass('l-offcanvas l-offcanvas--mobile-nav');
        $('.c-sub-nav--active').removeClass('c-sub-nav--active');
        $('.c-sub-sub-nav--active').removeClass('c-sub-sub-nav--active');
    }
};

// DOM ready
$(() => {
    offcanvas.bindHamburger();
});

export default offcanvas;
